import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, Input, OnDestroy, OnInit, Optional, ViewChild } from '@angular/core';

import { ActivatedRoute } from '@angular/router';
import { AbstractItem } from '@business/base/abstract-item';
import { AbstractItemService } from '@business/base/abstract-item.service';
import { MarketEnum } from '@model/enum/market.enum';
import { MessageQuote } from '@model/webFeeder/message-quote.model';
import { BilletOrderModalService } from '@services/billet-order-modal.service';
import { ConfigService } from '@services/webFeeder/config.service';
import { QuoteService } from '@services/webFeeder/sckt-quotes.service';
import { WorkspaceNewService } from '@services/workspace-new.service';
import { AppUtils } from '@utils/app.utils';
import { Constants } from '@utils/constants';
import { NotificationsService } from 'angular2-notifications';
import { Subject, Subscription , of } from 'rxjs';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: Constants.WINDOW_NAME_ASSET_SUMMARY,
  templateUrl: './asset-summary.component.html'
})
export class AssetSummaryComponent extends AbstractItem implements OnInit, OnDestroy {

  @ViewChild('tooltipMin') tooltipMin: MatTooltip;
  @Input() override data: any;
  @Input() showClose: any;
  componentName = Constants.WINDOW_NAME_ASSET_SUMMARY;
  newWindow = false;
  _messageQuote = new MessageQuote();
  windowActive: any;
  assetValid = true;
  private subscriptionQuote: Subscription;
  override dialog: MatDialog;
  currentSymbol;
  protected override workspaceService: WorkspaceNewService;
  oldSymbol;
  hiddenInvalid: boolean;
  hiddenInvalidActive: boolean;
  directionUnansweredQty: number;
  changingValue: Subject<boolean> = new Subject();
  company: string;
  symbolTemp: string;
  broadcastChannel: BroadcastChannel;
  auctionHammer: boolean;
  showVariation: boolean;
  isUpdateOnDemand: boolean;
  imgName: any;
  loadingImgName: boolean;
  tabName: any;
  tabChange: any;
  priceTheory: number;
  varTheory: string;
  timeToOpen: string;
  lastTrade: string;
  bid: string;
  ask: string;
  removeFromWksTooltip = Constants.TOOLTIP_REMOVE_WKS_TOOL;
  firstLoad: boolean;
  msgQuotesformattedCurrency = { lastTrade: '', bid: '', ask: '', high: '', low: '', open: '', previous: '' };
  tunnelLowerLimit = '';
  tunnelUpperLimit = '';
  quantityOpenedContractNumber = '';
  marketNames = Constants.MARKET_NAMES;
  contractMultiplier = '';
  variation = { weekly: '', monthly: '', annual: '', previousWeek: '', previousMonth: '', previousYear: '' };
  delta = { volHora: '', volHoraAcum: '', volDay: '' };
  deltaBarsWidth = {
    volHora: { green: 0, yellow: 0, red: 0 },
    volHoraAcum: { green: 0, yellow: 0, red: 0 },
    volDay: { green: 0, yellow: 0, red: 0 }
  };
  chart = { currentPricePosition: '', currentPriceTransform: '', barPosition: '', barWidth: '', avgPricePosition: '', isPositive: false, hidden: false };

  showExpandCard = this.configService.getShowExpandCard(this.componentName);

  constructor(
    private quoteService: QuoteService,
    workspaceService: WorkspaceNewService,
    private route: ActivatedRoute,
    private configService: ConfigService,
    itemService: AbstractItemService,
    dialog: MatDialog,
    @Optional() @Inject(MAT_DIALOG_DATA) public injectedSymbol,
    private _billetOrderService: BilletOrderModalService,
    public _NotificationService: NotificationsService,
    private _datePipe: DatePipe,
  ) {
    super(workspaceService, dialog, itemService);
    this.dialog = dialog;
    this.workspaceService = workspaceService;
    this.tabName = new Array();
    this.tabName.push({ description: 'Cotação', value: 0, selected: true });
    this.tabName.push({ description: 'Range', value: 60, selected: false });
    this.tabName.push({ description: 'Ofertas', value: 60, selected: false });
    this.tabName.push({ description: 'Negócios', value: 60, selected: false });
    this.tabName.push({ description: 'Gráfico', value: 60, selected: false });
  }

  ngOnInit() {
    if (this.injectedSymbol) {
      this.data = this.injectedSymbol.injectedSymbol;
    }
    if (this.route.snapshot.queryParams['ativo']) {
      this.data = this.route.snapshot.queryParams['ativo'];
    }
    if (this.data && this.data.symbol) {
      this.currentSymbol = this.data.symbol;
      this.firstLoad = true;
      this.subscribeQuote(this.currentSymbol);
    } else {
      this.route.queryParams.subscribe(params => {
        if (params['ativo']) {
          this.newWindow = true;
          this.currentSymbol = params['ativo'];
          this.broadcastChannel = new BroadcastChannel(this.componentName + '-' + this.currentSymbol);
          this.data = { symbol: this.currentSymbol };
          this.subscribeQuote(this.currentSymbol);
        }
      });
    }
  }

  hiddenInvalidOutput(value: any) {
    this.assetValid = value;
  }

  ngOnDestroy() {
    this.unsubscribeQuote();
    if (this.broadcastChannel) {
      this.broadcastChannel.close();
    }
    this.closeSheet();
    this.changingValue.unsubscribe();
  }

  unsubscribeQuote() {
    if (this.quoteService && this.currentSymbol) {
      this.quoteService.unsubscribeQuote(this.currentSymbol, this.componentName);
      if (this.subscriptionQuote) {
        this.subscriptionQuote.unsubscribe();
      }
    }
  }

  closeSheet() {
    if (this.windowActive != null) {
      this.windowActive.close();
    }
  }

  resetQuote() {
    this.assetValid = false;
    this.hiddenInvalidActive = false;
    this.currentSymbol = '';
    this.imgName = '';
    this.company = null;
    this.msgQuotesformattedCurrency.lastTrade = '';
    this.lastTrade = '';
    this._messageQuote = new MessageQuote();
    this.clearVariationObj();
    return;
  }

  selectAsset(event) {
    if (event) {
      if (this.data) {
        this.data.symbol = event.symbol;
      }
      if (event.symbol === '') {
        if (this.oldSymbol !== undefined) {
          super.updateOnDemand(this.data.symbol, event.symbol);
        }
        this.oldSymbol = undefined;
        this.currentSymbol = '';
      }
      this.subscribeQuote(event.symbol, true);
    }
  }

  subscribeQuote(symbol: any, isNewSymbol: boolean = false) {
    if (symbol) {
      symbol = AppUtils.trimStart(symbol);
      this.oldSymbol = this.currentSymbol ? this.currentSymbol : '';
      if (this.oldSymbol && symbol && this.oldSymbol.toLowerCase() === symbol.toLowerCase()
        && this.subscriptionQuote) {
        return;
      }
      if (symbol.toLowerCase() === 'invalid' || symbol === '') {
        this.hiddenInvalid = false;
        this.resetQuote();
        this.currentSymbol = '';
        return;
      }
      // if (isNewSymbol && super.validateOnlyOneAssetAssigned(symbol, this.data.type, this.data.workspaceId) === true) {
      //   this._NotificationService.error('', Constants.WORKSPACE_MSG015);
      //   this.currentSymbol = '';
      //   setTimeout(() => {
      //     this.currentSymbol = this.oldSymbol;
      //   }, 1000);
      //   return;
      // }
      this.resetQuote();
      this.currentSymbol = symbol;
      const msgItem = this.quoteService.subscribeQuote(this.currentSymbol, this.componentName);
      if (msgItem !== undefined && msgItem !== '') {
        this.resetQuote();
        return;
      }
      this.isUpdateOnDemand = false;
      this.loadingImgName = true;
      this.subscriptionQuote = this.quoteService.messagesQuote
        .subscribe((msg: MessageQuote) => {
          if (msg && msg.errorMessage && (this.currentSymbol && msg.symbol.toLowerCase() === this.currentSymbol.toLowerCase())) {
            this.quoteService.unsubscribeQuote(msg.symbol.toLowerCase(), this.componentName);
            this.currentSymbol = null;
            this.resetQuote();
          } else if (msg !== undefined && msg.symbol != null && msg.symbol === this.currentSymbol) {
            this._messageQuote = msg;
            if (this.loadingImgName) {
              this.imgName = './assets/images/symbols/' + AppUtils.getImageSymbol(msg.symbol, msg.marketType).toUpperCase() + '.PNG';
              this.loadingImgName = false;
            }
            if (!this.isUpdateOnDemand) {
              this.isUpdateOnDemand = true;
              if (!this.newWindow) {
                super.updateOnDemand(this.oldSymbol, this.currentSymbol);
              }
            }
            const tickSize = this._messageQuote.tickSize && this._messageQuote.marketType && this._messageQuote.marketType === MarketEnum.BITCOIN ? 3 :
              this._messageQuote.tickSize ? this._messageQuote.tickSize : 2;
            this.hiddenInvalidActive = false;
            this.assetValid = true;
            this.changingValue.next(true);
            if (this._messageQuote.lastTrade && this._messageQuote.lastTrade.toString() !== '-' && this._messageQuote.lastTrade.toString() !== '0,00'
              && this._messageQuote.lastTrade.toString() !== '0') {
              const lastTradeNumber = AppUtils.convertNumber(this._messageQuote.lastTrade.toString().replace('.', ''));
              this._messageQuote.lastTrade = AppUtils.convertToNumber(lastTradeNumber.toString(), tickSize);
              this.lastTrade = AppUtils.convertNumberToCurrency(lastTradeNumber, tickSize);
            } else {
              if (this._messageQuote.lastTrade &&
                (this._messageQuote.lastTrade.toString() === '-' || this._messageQuote.lastTrade.toString() === '0,00' || this._messageQuote.lastTrade.toString() === '0'
                  || Number(this._messageQuote.lastTrade) <= 0)) {
                const lastTradeNumber = AppUtils.convertNumber(this._messageQuote.previous.toString().replace('.', ''));
                this._messageQuote.lastTrade = AppUtils.convertToNumber(lastTradeNumber.toString(), tickSize);
                this.lastTrade = AppUtils.convertNumberToCurrency(lastTradeNumber, tickSize);
              }
            }
            if (this._messageQuote.theoryPrice && (this._messageQuote.theoryPrice > 0 ||
              (this._messageQuote.theoryPrice.toString() !== '-' && Number(this._messageQuote.theoryPrice.toString().replace(',', '.'))))) {
              this.priceTheory = AppUtils.convertBrCurrencyToNumber(this._messageQuote.theoryPrice.toString(), ',');
              this.auctionHammer = true;
              this.timeToOpen = this._messageQuote.timeToOpen;
              let previousConst = 0;
              if (this._messageQuote.previous && this._messageQuote.previous.toString() !== '-') {
                previousConst = AppUtils.convertBrCurrencyToNumber(this._messageQuote.previous.toString(), ',');
              }
              if (this.priceTheory > 0 && previousConst > 0) {
                let varTheoryTemp = ((this.priceTheory / previousConst) - 1) * 100;
                if (varTheoryTemp !== 0) {
                  varTheoryTemp = Number(Number(varTheoryTemp).toFixed(2));
                  this.varTheory = AppUtils.convertNumberToCurrency(varTheoryTemp, null, '');
                }
              }
            } else {
              this.priceTheory = 0;
              this.varTheory = null;
              this.timeToOpen = null;
              this.auctionHammer = false;
            }
            if (this._messageQuote.dateLastNegotiation) {
              const today = this._datePipe.transform(new Date(), 'dd/MM/yyyy');
              this.showVariation = today === this._messageQuote.dateLastNegotiation ? true : false;
            } else {
              this.showVariation = true;
            }
            if (this._messageQuote.description && this._messageQuote.description !== '' && this._messageQuote.marketType === Constants.MARKET_CODE_BOVESPA) {
              this.company = this._messageQuote.description + ' ' + this._messageQuote.classification;
            } else {
              this.company = this._messageQuote.description;
            }
            Object.keys(this.msgQuotesformattedCurrency).forEach(info => {
              if (!this._messageQuote[info]) {
                return;
              }
              const infoValueAsNumber = AppUtils.convertFormattedNumberToNumber(this._messageQuote[info]);
              this.msgQuotesformattedCurrency[info] = AppUtils.numberToCurrency(infoValueAsNumber, tickSize);
            });
            if (this._messageQuote.volumeAmount) {
              const isShortFormatNumber = Number.isNaN(Number(this._messageQuote.volumeAmount));
              this._messageQuote.volumeAmount = isShortFormatNumber ? this._messageQuote.volumeAmount.replace('.', ',')
                : AppUtils.numberToFormattedNumber(Number(this._messageQuote.volumeAmount), 2, ',');
            }
            if (this._messageQuote.volumeFinancier) {
              const isShortFormatNumber = Number.isNaN(Number(this._messageQuote.volumeFinancier));
              this._messageQuote.volumeFinancier = isShortFormatNumber ? this._messageQuote.volumeFinancier.replace('.', ',')
                : AppUtils.numberToFormattedNumber(Number(this._messageQuote.volumeFinancier), 2, ',');
            }
            if (this._messageQuote.tunnelLowerLimit) {
              this.tunnelLowerLimit = AppUtils.numberToCurrency(Number(this._messageQuote.tunnelLowerLimit), tickSize);
            }
            if (this._messageQuote.tunnelUpperLimit) {
              this.tunnelUpperLimit = AppUtils.numberToCurrency(Number(this._messageQuote.tunnelUpperLimit), tickSize);
            }
            if (this._messageQuote.quantityOpenedContractNumber) {
              const isShortFormatNumber = Number.isNaN(Number(this._messageQuote.volumeFinancier));
              this.quantityOpenedContractNumber = isShortFormatNumber ? this._messageQuote.quantityOpenedContractNumber.replace('.', ',')
                : AppUtils.numberToFormattedNumber(Number(this._messageQuote.quantityOpenedContractNumber), 2, ',');
            }
            if (this._messageQuote.contractMultiplier) {
              this.contractMultiplier = AppUtils.numberToFormattedNumber(Number(this._messageQuote.contractMultiplier));
            }
            this.setDeltaTabObj();
            this.setVariationObj();
            this.setChartObj();
          }
        });

    }
  }

  setChartObj() {
    const isInvalid = (value: string | number) => (!value && value !== 0) || value === '-';
    if (
      isInvalid(this._messageQuote.low) || isInvalid(this._messageQuote.high)
      || isInvalid(this._messageQuote.lastTrade) || isInvalid(this._messageQuote.open)
    ) {
      this.chart.hidden = true;
      return;
    }
    const minPrice = AppUtils.convertFormattedNumberToNumber(this._messageQuote.low);
    const maxPrice = AppUtils.convertFormattedNumberToNumber(this._messageQuote.high);
    const currPrice = AppUtils.convertFormattedNumberToNumber(this._messageQuote.lastTrade);
    const openPrice = AppUtils.convertFormattedNumberToNumber(this._messageQuote.open);
    this.chart.hidden = false;
    if (isInvalid(this._messageQuote.average)) {
      this.chart.avgPricePosition = '';
    } else {
      const avgPrice = AppUtils.convertFormattedNumberToNumber(this._messageQuote.average);
      const avgPricePosition = ((avgPrice - minPrice) * 100) / (maxPrice - minPrice);
      this.chart.avgPricePosition = `${avgPricePosition}%`;
    }
    const currPricePosition = ((currPrice - minPrice) * 100) / (maxPrice - minPrice);
    this.chart.currentPricePosition = `${currPricePosition}%`;
    this.chart.currentPriceTransform = `translateX(-${currPricePosition}%)`;
    const openPricePosition = ((openPrice - minPrice) * 100) / (maxPrice - minPrice);
    if (openPrice < currPrice) {
      this.chart.barPosition = `${openPricePosition}%`;
      this.chart.barWidth = `${currPricePosition - openPricePosition}%`;
      this.chart.isPositive = true;
    } else if (openPrice > currPrice) {
      this.chart.barPosition = `${currPricePosition}%`;
      this.chart.barWidth = `${openPricePosition - currPricePosition}%`;
      this.chart.isPositive = false;
    }
  }

  setDeltaTabObj() {
    const deltaVolHora = this._messageQuote.deltaVolumeAccumulatedHour;
    const deltaVolHoraAcum = this._messageQuote.deltaVolumeCurrentTime;
    const { volAVG20, volumeAmount } = this._messageQuote;
    if (deltaVolHora) {
      const deltaVolHoraNumber = AppUtils.convertFormattedNumberToNumber(deltaVolHora);
      if (Number.isNaN(deltaVolHoraNumber)) {
        this.delta.volHora = '- %';
        this.deltaBarsWidth.volHora.green = 0;
        this.deltaBarsWidth.volHora.yellow = 0;
        this.deltaBarsWidth.volHora.red = 0;
      } else {
        this.delta.volHora = AppUtils.numberToCurrency(deltaVolHoraNumber, 2) + '%';
        this.deltaBarsWidth.volHora.green = (deltaVolHoraNumber < 100) ? deltaVolHoraNumber : 100;
        this.deltaBarsWidth.volHora.yellow = (deltaVolHoraNumber - this.deltaBarsWidth.volHora.green) < 100 ? (deltaVolHoraNumber - this.deltaBarsWidth.volHora.green) : 100;
        this.deltaBarsWidth.volHora.red = this.deltaBarsWidth.volHora.yellow === 100 ? (deltaVolHoraNumber - 200) : 0;
      }
    }
    if (deltaVolHoraAcum) {
      const deltaVolAcumNumber = AppUtils.convertFormattedNumberToNumber(deltaVolHoraAcum);
      if (Number.isNaN(deltaVolAcumNumber)) {
        this.delta.volHoraAcum = '- %';
        this.deltaBarsWidth.volHoraAcum.green = 0;
        this.deltaBarsWidth.volHoraAcum.yellow = 0;
        this.deltaBarsWidth.volHoraAcum.red = 0;
      } else {
        this.delta.volHoraAcum = AppUtils.numberToCurrency(deltaVolAcumNumber, 2) + '%';
        this.deltaBarsWidth.volHoraAcum.green = (deltaVolAcumNumber < 100) ? deltaVolAcumNumber : 100;
        this.deltaBarsWidth.volHoraAcum.yellow = (deltaVolAcumNumber - this.deltaBarsWidth.volHoraAcum.green) < 100
          ? (deltaVolAcumNumber - this.deltaBarsWidth.volHoraAcum.green)
          : 100;
        this.deltaBarsWidth.volHoraAcum.red = this.deltaBarsWidth.volHoraAcum.yellow === 100 ? (deltaVolAcumNumber - 200) : 0;
      }
    }
    if (volAVG20 && volumeAmount) {
      const volumeAvg20dNumber = /.(K|M|B)$/.test(volAVG20) ? AppUtils.convertOptimizedNumberToNumber(volAVG20) : AppUtils.convertFormattedNumberToNumber(volAVG20);
      const volumeAmountNumber = /.(K|M|B)$/.test(volumeAmount) ? AppUtils.convertOptimizedNumberToNumber(volumeAmount) : AppUtils.convertFormattedNumberToNumber(volumeAmount);
      if (!volumeAvg20dNumber || !volumeAmountNumber) {
        this.delta.volDay = '- %';
        this.deltaBarsWidth.volDay.green = 0;
        this.deltaBarsWidth.volDay.yellow = 0;
        this.deltaBarsWidth.volDay.red = 0;
      } else {
        const valuePercentage = (volumeAmountNumber * 100) / volumeAvg20dNumber;
        this.delta.volDay = AppUtils.numberToCurrency(valuePercentage, 2) + '%';
        this.deltaBarsWidth.volDay.green = (valuePercentage < 100) ? valuePercentage : 100;
        this.deltaBarsWidth.volDay.yellow = (valuePercentage - this.deltaBarsWidth.volDay.green) < 100 ? (valuePercentage - this.deltaBarsWidth.volDay.green) : 100;
        this.deltaBarsWidth.volDay.red = this.deltaBarsWidth.volDay.yellow === 100 ? (valuePercentage - 200) : 0;
      }
    }
  }

  clearVariationObj() {
    this.variation = {
      weekly: ' - ',
      monthly: ' - ',
      annual: ' - ',
      previousWeek: ' - ',
      previousMonth: ' - ',
      previousYear: ' - '
    };
  }

  setVariationObj() {
    this.clearVariationObj();
    if (this._messageQuote.calculoWeeklyVariation) {
      const valueAsNumber = AppUtils.convertFormattedNumberToNumber(this._messageQuote.calculoWeeklyVariation);
      if (valueAsNumber) {
        const sign = valueAsNumber > 0 ? '+' : '';
        this.variation.previousWeek = sign + AppUtils.numberToCurrency(valueAsNumber, 2) + '%';
      }
    }
    if (this._messageQuote.calculoMonthlyVariation) {
      const valueAsNumber = AppUtils.convertFormattedNumberToNumber(this._messageQuote.calculoMonthlyVariation);
      if (valueAsNumber) {
        const sign = valueAsNumber > 0 ? '+' : '';
        this.variation.previousMonth = sign + AppUtils.numberToCurrency(valueAsNumber, 2) + '%';
      }
    }
    if (this._messageQuote.calculoYearlyVariation) {
      const valueAsNumber = AppUtils.convertFormattedNumberToNumber(this._messageQuote.calculoYearlyVariation);
      if (valueAsNumber) {
        const sign = valueAsNumber > 0 ? '+' : '';
        this.variation.previousYear = sign + AppUtils.numberToCurrency(valueAsNumber, 2) + '%';
      }
    }
    if (!this._messageQuote.lastTrade) {
      return;
    }
    const lastTrade = this._messageQuote.lastTrade;
    if (this._messageQuote.previousWeek) {
      const valueAsNumber = AppUtils.convertFormattedNumberToNumber(this._messageQuote.previousWeek);
      if (valueAsNumber) {
        const percentage = ((lastTrade / valueAsNumber) - 1) * 100;
        const sign = percentage > 0 ? '+' : '';
        this.variation.weekly = sign + AppUtils.numberToCurrency(percentage, 2) + '%';
      }
    }
    if (this._messageQuote.previousMonth) {
      const valueAsNumber = AppUtils.convertFormattedNumberToNumber(this._messageQuote.previousMonth);
      if (valueAsNumber) {
        const percentage = ((lastTrade / valueAsNumber) - 1) * 100;
        const sign = percentage > 0 ? '+' : '';
        this.variation.monthly = sign + AppUtils.numberToCurrency(percentage, 2) + '%';
      }
    }
    if (this._messageQuote.previousYear) {
      const valueAsNumber = AppUtils.convertFormattedNumberToNumber(this._messageQuote.previousYear);
      if (valueAsNumber) {
        const percentage = ((lastTrade / valueAsNumber) - 1) * 100;
        const sign = percentage > 0 ? '+' : '';
        this.variation.annual = sign + AppUtils.numberToCurrency(percentage, 2) + '%';
      }
    }
  }

  openNewWindow() {
    if (this.currentSymbol) {
      const options = 'width=300px, height=305';
      window.name = Constants.WINDOW_NAME_MAIN_WINDOW;
      if (!this.broadcastChannel) {
        this.broadcastChannel = new BroadcastChannel(this.componentName + '-' + this.currentSymbol);
        this.broadcastChannel.onmessage = ((message) => this.buySellOrder(message.data.value, message.data.asset));
      }
      const parameters = '?ativo=' + this.currentSymbol;
      if (this.windowActive == null || this.windowActive.closed) {
        super.getNewWindow('asset-summary', parameters, options, this.data.id)
          .subscribe(window => {
            this.windowActive = window;
          });
      } else {
        this.windowActive.focus();
      }
    } else {
      this._NotificationService.warn('', Constants.WORKSPACE_MSG025);
    }
  }

  buySellOrder(value, asset?: string, price?: string): void {
    if (!price || price === '-') {
      return;
    }
    if (this.newWindow) {
      window.open('', Constants.WINDOW_NAME_MAIN_WINDOW).focus();
      this.broadcastChannel.postMessage({ value: value, asset: this.currentSymbol });
    } else {
      this._billetOrderService.buySellOrder(value, this.currentSymbol || asset, price);
    }
  }

  changeTab($event) {
    this.tabChange = $event;
  }

}
